/** @format */

import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('SalesStore')
@observer
class SaleBoxes extends Component {
  renderSaleBoxes = () => {
    const { SalesStore } = this.props;
    let saleBoxes = SalesStore.currentSale.data.shipping.boxes;
    let saleBoxesKeys = saleBoxes ? Object.keys(saleBoxes) : [];
    let renderSaleBoxes = saleBoxesKeys.map(key => {
      return (
        <Table.Row key={'box-' + key}>
          <Table.Cell>{saleBoxes[key].method}</Table.Cell>
          <Table.Cell>{saleBoxes[key].height}cm</Table.Cell>
          <Table.Cell>{saleBoxes[key].width}cm</Table.Cell>
          <Table.Cell>{saleBoxes[key].depth}cm</Table.Cell>
          <Table.Cell>{saleBoxes[key].weight}Kg</Table.Cell>
          <Table.Cell>{saleBoxes[key].price}€</Table.Cell>
        </Table.Row>
      );
    });
    return renderSaleBoxes;
  };

  rederTableHead = () => {
    let tableKeys = ['Metodo', 'A', 'L', 'P', 'peso', 'prezzo'];
    let renderTableHead = tableKeys.map((tableKey, index) => {
      return (
        <Table.Cell key={'boxesTableHead-' + index}>
          <strong>{tableKey}</strong>
        </Table.Cell>
      );
    });
    return renderTableHead;
  };

  renderShipping() {
    const { SalesStore } = this.props;
    let renderShipping = null;
    if (SalesStore.currentSale.data.shippingType === 'spedizione') {
      renderShipping = (
        <Table
          size="small"
          compact
          basic="very"
          celled
          className="no-margin-top"
        >
          <Table.Body>
            <Table.Row>{this.rederTableHead()}</Table.Row>
            {this.renderSaleBoxes()}
          </Table.Body>
        </Table>
      );
    }
    if (SalesStore.currentSale.data.shippingType === 'ritiro in magazzino') {
      renderShipping = <p>Previsto ritiro in magazzino</p>;
    }
    if (
      SalesStore.currentSale.data.shippingType ===
      'trasferimento a sede di Cagliari'
    ) {
      renderShipping = <p>Da trasferire alla sede di Cagliari</p>;
    }

    return renderShipping;
  }

  render() {
    return this.renderShipping();
  }
}

export default SaleBoxes;
